import React from 'react'
import MethodMapping from '../Shared/MethodMapping/MethodMapping'

const PaymentMapping = ({ connectorId, instancesId }) => (
    <MethodMapping
        resource="payment"
        title="Payment Method Mapping"
        entityLabel="payment method"
        emptyIcon="uil-credit-card"
        idPrefix="payment"
        connectorId={connectorId}
        instancesId={instancesId}
    />
)

export default PaymentMapping
